module.exports = __webpack_public_path__ + "static/media/icon_cashback.7f3621b7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Home/components/imgs/icon_cashback.svg
// module id = 816
// module chunks = 0